module.exports = __webpack_public_path__ + "static/media/modal-img.6b37386f.svg";